module.exports = __webpack_public_path__ + "static/media/icn_lightbox_close.c5637ea3.svg";